"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerInputCalendarButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("../../../../i18n/i18n");
var _useTheme = require("../../../../theme/utils/useTheme");
var _DatePickerCalendarButton = require("../styled/DatePickerCalendarButton");
const DatePickerInputCalendarButton = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    clientId,
    isDisabled,
    isReadOnly,
    inputFieldHeight,
    ...rest
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const {
    i18n
  } = (0, _i18n.useI18n)();
  const isUrsaLight = themeMode.includes("ursa");
  const sharedProps = {
    ...rest,
    "aria-label": i18n._( /*i18n*/"date picker"),
    isDisabled,
    clientId: (0, _lodestarUtils.getClientId)(clientId, "dp-calendar-button"),
    ref: ref
  };
  const ursaProps = isUrsaLight ? {
    appearance: "secondary-empty",
    iconBefore: /*#__PURE__*/_react.default.createElement(_ursaIcons.CalendarIcon, {
      "data-client-id": "test1",
      size: inputFieldHeight === 40 ? 20 : 16,
      style: inputFieldHeight === 40 ? {
        marginRight: "2px"
      } : undefined
    }),
    size: inputFieldHeight === 40 ? "small" : "xsmall"
  } : {};
  return /*#__PURE__*/_react.default.createElement(_DatePickerCalendarButton.DatePickerCalendarButton, (0, _extends2.default)({
    className: (0, _clsx.default)((isDisabled || isReadOnly) && `is-disabled`),
    themeMode: themeMode
  }, ursaProps, sharedProps), !isUrsaLight && /*#__PURE__*/_react.default.createElement(_lodestarIcons.ColoredDatePickerIcon, null));
});
exports.DatePickerInputCalendarButton = DatePickerInputCalendarButton;
DatePickerInputCalendarButton.displayName = "DatePickerInputCalendarButton";
//# sourceMappingURL=DatePickerInputCalendarButton.js.map